import { QGetLimitsHistory } from "./QGetLimitsHistory";
import { QGetPlayer } from "./QGetPlayer";
export const QueryBuilder = {
    getLimitsHistory: QGetLimitsHistory,
    getPlayer: QGetPlayer
};
//# sourceMappingURL=index.js.map